import React, { FunctionComponent, useState, useEffect } from "react";
import { Grid, Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { Helmet } from "react-helmet-async";
import { useVoucherStyles } from "./useVoucherStyles";
import { VoucherTable } from "./VoucherView/VoucherTable";
import { useStore } from "../../store";
//import { SnackBar } from "../SnackBar";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
type permissionType = {
  permission_id: number;
  is_add: boolean;
  is_edit: boolean;
  is_view: boolean;
  is_delete: boolean;
};
export const TabPanel: FunctionComponent<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //   {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};
export const VoucherMaster = () => {
  const classes = useVoucherStyles();
  const [value, setValue] = React.useState(0);
  const [viewVoucherPermission, setViewVoucherPermission] = useState<boolean>(
    false
  );
  const [editVoucherPermission, setEditVoucherPermission] = useState<boolean>(
    false
  );
  const [user] = useStore("auth", "user");

  /* useEffect(() => {
    const voucherPermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 21
    );
    if (user.is_super_admin === true) {
      setViewVoucherPermission(true);
      setEditVoucherPermission(true);
    } else {
      if (voucherPermission) {
        if (voucherPermission.is_edit === true) {
          setEditVoucherPermission(true);
        }
        if (voucherPermission.is_view === true) {
          setViewVoucherPermission(true);
        }
      }
    }
  }); */

  useEffect(() => {
    const voucherPermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 21
    );
    if (user.is_super_admin === true) {
      setViewVoucherPermission(true);
      setEditVoucherPermission(true);
    } else {
      if (voucherPermission) {
        if (voucherPermission.is_edit === true) {
          setEditVoucherPermission(true);
        }
        if (voucherPermission.is_view === true) {
          setViewVoucherPermission(true);
        }
      }
    }
  }, [user.permissions, user.is_super_admin]);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <Helmet>
        <title>Vouchers</title>
      </Helmet>
      <Grid
        container
        spacing={2}
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item xs={12} className={classes.root}>
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              <Tab
                label="Voucher List"
                style={{ display: viewVoucherPermission ? "" : "none" }}
              />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <VoucherTable editVoucherPermission={editVoucherPermission} />
          </TabPanel>
        </Grid>
      </Grid>
    </>
  );
};
